import { Coupon } from '@dtx-company/true-common/src/types/Coupon'
import { SubscriptionServiceGetCouponJSON } from './types/jsons/SubscriptionServiceGetCouponJSON'
import { fetchSubscriptionServiceUrl } from './fetchSubscriptionServiceUrl'
import { getPlans } from './getPlans'
import { migrateSubscriptionServiceCoupon } from './serialization/migrateSubscriptionServiceCoupon'

// Endpoint is plural, but only works to fetch a single coupon at a time
const GET_COUPON_URL = '/coupons'

export interface GetCouponOptions {
  code: string
  include?: {
    plans?: boolean
  }
}

/**
 * Calls the subscription service GET /coupons endpoint.
 *
 * If the coupon does not exist, this will return `null`.
 */
export async function getCoupon({ code, include }: GetCouponOptions): Promise<Coupon | null> {
  const response = await fetchSubscriptionServiceUrl<SubscriptionServiceGetCouponJSON>({
    url: GET_COUPON_URL,
    query: {
      couponCode: code
    }
  })

  if (!response.ok) {
    if (response.status === 404) {
      return null
    }
    throw new Error(`Received http status ${response.status} from ${GET_COUPON_URL} endpoint`)
  }
  if (!response.json) {
    throw new Error(`The ${GET_COUPON_URL} endpoint did not return a json payload`)
  }
  if (response.json.statusDescription !== 'success-retrieval') {
    throw new Error(`The ${GET_COUPON_URL} endpoint did not return a "success-retrieval"`)
  }
  if (response.json.couponStatus !== 'OK') {
    return null
  }

  const plans =
    include?.plans && Array.isArray(response.json.plans) && response.json.plans.length > 0
      ? await getPlans({
          filter: { planId: response.json.plans }
        })
      : []

  return migrateSubscriptionServiceCoupon(response.json, { code, plans })
}

getCoupon.swrKey = 'getCoupon'
